import { StakingBackground } from '../common/StakingBackground'

export function RswellBackground() {
  return (
    <>
      <StakingBackground />
    </>
  )
}
